import React, { useState } from 'react';
import { autoCreateLines, getLines } from '../../API';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useLinesContext } from '../../../contexts/Lines';
import { CustomTooltip } from '../../BuildingBlocks/Tooltip/Tooltip';
import { cancelButton } from '../../../themes/styles';
import messages from '../../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  body: { marginTop: theme.spacing(2), marginBottom: theme.spacing(3) },
  productName: { cursor: 'default' },
  productNameTooltip: { margin: theme.spacing(1) },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .MuiButton-label': { fontWeight: 'bold' },
  },
  cancelButton: { ...(cancelButton as object), marginRight: theme.spacing(2) },
  widthButton: {
    minWidth: '140px',
    padding: theme.spacing(1),
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loader: { color: 'black', marginRight: theme.spacing(2) },
  loadingMsg: { fontWeight: 'bold' },
}));

export default function Create({ handleSuccess, handleClose, lineToTemplate }) {
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const { products, lines, setLines } = useLinesContext();
  const product = products?.find(
    (product) => product.id === lineToTemplate.product,
  );
  let productName = product?.name;
  if (productName?.length > 20) {
    productName = product.name.slice(0, 21) + '...';
  }

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState('Generating new Lines');

  async function handleSubmit() {
    try {
      setLoading(true);
      const autoCreatedLines = await autoCreateLines(lineToTemplate.id);
      setLoadingMsg('Retrieving new Lines');
      let newLines = await getLines(autoCreatedLines.lineIds);
      setLines([...lines, ...newLines]);
      handleSuccess(autoCreatedLines.lineIds.length);
    } catch (error) {
      snackbar.show(messages.lines.autoCreate.generalError, 'error');
    }
    setLoading(false);
  }

  return (
    <>
      {!product && (
        <>
          <Typography paragraph>
            We couldn't find any valid products. To generate Lines using
            Artificial Intelligence, you need to have at least one Line.
          </Typography>
          <Button color="primary" variant="contained" onClick={handleClose}>
            Ok
          </Button>
        </>
      )}
      {product && (
        <>
          <Typography paragraph className={classes.body}>
            Would you like us to generate your upcoming Lines for{' '}
            <CustomTooltip
              arrow
              placement="top"
              title={
                <Typography className={classes.productNameTooltip}>
                  {product?.name}
                </Typography>
              }
            >
              <b className={classes.productName}>{productName}</b>
            </CustomTooltip>
            ? Don’t worry, you’ll be able to edit anything that doesn’t align
            with your Plans.
          </Typography>
          <div className={classes.buttons}>
            {loading && (
              <div className={classes.loadingContainer}>
                <CircularProgress
                  color="primary"
                  size={40}
                  className={classes.loader}
                />
                <Typography className={classes.loadingMsg}>
                  {loadingMsg}
                </Typography>
              </div>
            )}
            {!loading && (
              <div>
                <Button
                  className={classes.cancelButton + ' ' + classes.widthButton}
                  onClick={handleClose}
                >
                  Maybe later
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleSubmit}
                  className={classes.widthButton}
                >
                  Yes, please!
                </Button>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
